import { Tag } from './tag';

interface TagProps {
  items: Array<string>;
  className?: string;
}

export default function Tags(props: TagProps) {
  const { items, className } = props;
  return items?.length > 0 &&
    (
      <div className={`flex justify-center gap-x-1 ${className}`} data-testid="tag-div">
        {items.map((item: any, i) => {
          return <Tag tagTitle={item} key={i} className={className}/>
        })}
      </div>
    );
}
